<template>
	<div class="nav nav-tabs custom bg-white" id="nav-tab" role="tablist">
		<a class="nav-item nav-link"
		   :class="{'active': selected === m.id}"
		   v-for="m in menus"
		   :key="m.id"
		   :id="m.id"
		   :data-toggle="validateAccess(m.accessKey) ? 'tab' : ''"
		   :href="'#' + m.id"
		   @click="showContainer(m)"
		   role="tab"
		   :aria-controls="m.id">
			{{ m.title }}
		</a>
	</div>
</template>

<script>
export default {
	name: "SOTab",
	props: {
		menus: Array,
		selected: String,
	},
	methods: {
		showContainer(m) {
			if (!this.validateAccess(m.accessKey)) return
			window.location.hash = m.id;
			this.$emit("selected", m.id)
		}
	}
}
</script>

<style scoped>
.nav-item {
	outline: none !important;
}

.nav-item:focus-visible {
	outline: none;
}

#nav-tab {
	position: fixed;
	top: 52px;
	left: 0;
	z-index: 1;
	width: 100%;
}
</style>